import { observer } from 'mobx-react';
import { GraduationCapIcon, Typography } from '@execonline-inc/execonline-ui';
import { T } from '../../../../../Translations';
import ExperienceAlert from './ExperienceAlert';

function GraduatedAlert() {
  return (
    <ExperienceAlert icon={<GraduationCapIcon />}>
      <Typography variant="caption">
        <T kind="You graduated from this program" />
      </Typography>
    </ExperienceAlert>
  );
}

export default observer(GraduatedAlert);
